import { AnyAction } from 'redux';
import { SelbststaendigkeitsArt } from '@ps20-frontend/frontend-models';
import { RsActions } from '../rsActions';

export const selbststaendigkeitReducer = function (
  sectionState: SelbststaendigkeitsArt = null,
  action: AnyAction,
): SelbststaendigkeitsArt {
  switch (action.type) {
    case RsActions.SELBSTSTAENDIGKEIT_CHANGED: {
      return { ...sectionState, selbststaendig: action.payload };
    }
    case RsActions.GESCHAEFTSFUEHRER_CHANGED: {
      return { ...sectionState, geschaeftsfuehrer: action.payload };
    }
    default:
      return sectionState;
  }
};
